import StepMenuContainer from '@r1-frontend/ui-react/components/StepMenu/StepMenuContainer';
import StepMenuItem from '@r1-frontend/ui-react/components/StepMenu/StepMenuItem';
import { TSvgProps } from '@r1-frontend/ui-react/components/svg/createSvg';

export type TStepTabsItem = {
    id: number,
    label: string,
    Icon?: (props: TSvgProps) => JSX.Element,
    Image?: string,
}

type TStepTabsProps = {
    items: TStepTabsItem[],
    current?: number, // the id of TStepTabsItems
    activatedSteps?: number,
    onClick: (id: number) => void,
};

export const StepTabs = ({ items, onClick, activatedSteps = 0, current = 0 }: TStepTabsProps): JSX.Element => {

    const handleClick = (id: number) => () => {
        onClick(id);
    };

    return (
        <StepMenuContainer><>
            {items.map(stepItem => (
                <StepMenuItem
                    key={`StepMenuItem_${stepItem.id}`}
                    isCurrent={stepItem.id === current}
                    isLastActivated={stepItem.id === activatedSteps}
                    {...stepItem}
                    onClick={handleClick(stepItem.id)}
                />
            ))}
        </></StepMenuContainer>
    );

};
